import { useCallback } from "react";
import { UI_ATOM_TEXT_HEADING } from "@rotorstudios/fe-ui";

import {
  CME_OPTIONSET_GRADE,
  UI_MOLECULE_SWIPER_SLIDES,
} from "../../_common/modules/Data/static";
import useCMSPageData from "../../_common/hooks/useCMSPageData";
import { useCmeContext } from "../../_common/modules/fe-cme/CMEProvider";
import { PAGE_GALLERY } from "../../_common/modules/fe-modules/Router/static";

export type UseGalleryProps = {
  mainContent: any;
};

const useGallery = (): UseGalleryProps => {
  const { cmeOptions } = useCmeContext();

  const { data } = useCMSPageData({
    page: PAGE_GALLERY,
    queryKey: "galleryPage",
    options: {
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  });

  const getSelectedGrade = useCallback(
    () => cmeOptions?.selectedOptions?.get(CME_OPTIONSET_GRADE),
    [cmeOptions?.selectedOptions],
  );

  const getSwiperSlidesItems = useCallback(
    (rawItems: any) =>
      rawItems.filter((item: any) => item.props.gradeId === getSelectedGrade()),
    [getSelectedGrade],
  );

  const getMainContent = useCallback(
    () =>
      data?.containers?.main.map((component: any) => {
        if (component.type === UI_ATOM_TEXT_HEADING) {
          return {
            ...component,
            props: {
              ...component.props,
            },
          };
        }
        if (component.type === UI_MOLECULE_SWIPER_SLIDES) {
          return {
            ...component,
            props: {
              ...component.props,
              items: getSwiperSlidesItems(component.props.items),
              showDownloadButtons: true,
            },
          };
        }
        return component;
      }),
    [data?.containers?.main, getSwiperSlidesItems],
  );

  return {
    mainContent: getMainContent(),
  };
};

export default useGallery;
